import { html, type Html, Page } from 'rune-ts';
import klass from './TodayContentLegacy.module.scss';
import { LayoutView } from '../../components/cells/Layout/LayoutView';
import { footer_links } from '../../components/cells/Footer/constant';
import { LegacyToday } from '../../../features/Curation/type';
import { typo } from '../../../shared/typography/typo';
import { BaseLayoutOptions } from '../../../features/Core/service';

export type TodayContentLegacyPageData = {
  layout_options: BaseLayoutOptions;
  feed: LegacyToday;
};

export class TodayContentLegacyPage extends Page<TodayContentLegacyPageData> {
  protected override template(data: TodayContentLegacyPageData): Html {
    const { layout_options, feed } = data;
    const { is_mobile } = layout_options;

    const body = html`
      <div class="${klass.body}">
        <h1 class="${klass.title} ${typo(is_mobile ? '32_bold' : '36_bold')}">${feed.title}</h1>
        <p class="${klass.description} ${typo(is_mobile ? '14_bold' : '16_bold')}">${feed.description}</p>
        <div class="editor_style_container">
          <div class="editor">${html.preventEscape(feed.content)}</div>
        </div>
      </div>
    `;

    return html`
      <div class="${klass.page}">
        <style>
          .editor-button-container {
            display: flex !important;
            justify-content: center !important;
          }
        </style>
        ${new LayoutView(
          {
            body,
            footer_data: {
              is_mobile,
              lang: ET.lang,
              ...footer_links,
            },
          },
          {
            ...layout_options,
            full_width: true,
          },
        )}
      </div>
    `;
  }
}
